import { createFileRoute } from "@tanstack/react-router";

import { AdminGuard } from "@/components/admin/AdminGuard";
import { PlaybookDetail } from "@/components/admin/playbooks/PlaybookDetail";

export const Route = createFileRoute("/admin/playbooks/$id")({
  component: AdminPlaybookDetailRoute,
});

function AdminPlaybookDetailRoute() {
  const { id } = Route.useParams();
  return (
    <AdminGuard>
      <PlaybookDetail id={id} />
    </AdminGuard>
  );
}
